module.exports = __webpack_public_path__ + "fonts/Alibaba-PuHuiTi-Regular.fea46b85.otf";